import Swiper from 'swiper/bundle';

export default class SwiperCtaJobs {
    constructor() {
        this.swiperCtaJobs = null;
    }

    init() {
        const jobsContainer = document.querySelector('.block-cta-metiers .swiperCtaJobs');
        if (jobsContainer) {
            this.toggleSwiperCtaJobs(true);
        }
        window.addEventListener('resize', this.checkScreenWidth.bind(this));
        document.addEventListener('DOMContentLoaded', () => {
            this.checkScreenWidth();
        });
    }

    toggleSwiperCtaJobs(enable) {
        const jobsContainer = document.querySelector('.block-cta-metiers .swiperCtaJobs');
        const jobItems = document.querySelectorAll('.block-cta-metiers .post');

        if (jobsContainer && jobItems.length) {
            if (enable) {
                if (!this.swiperCtaJobs) {
                    jobsContainer.classList.add('swiper');
                    jobItems.forEach(item => item.classList.add('swiper-slide'));

                    this.swiperCtaJobs = new Swiper(".swiperCtaJobs", {
                        slidesPerView: 1,
                        spaceBetween: 10,
                        breakpoints: {
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                            },
                        },
                        navigation: {
                            nextEl: ".block-cta-metiers .swiper-next",
                            prevEl: ".block-cta-metiers .swiper-prev",
                        },
                    });
                }
            } else {
                if (this.swiperCtaJobs) {
                    this.swiperCtaJobs.destroy(true, true);
                    this.swiperCtaJobs = null;

                    jobsContainer.classList.remove('swiper');
                    jobItems.forEach(item => item.classList.remove('swiper-slide'));

                    this.forceReflow(jobsContainer);
                }
            }
        }
    }

    forceReflow(element) {
        element.getBoundingClientRect();
    }

    checkScreenWidth() {
        if (window.innerWidth <= 1199) {
            this.toggleSwiperCtaJobs(true);
        } else {
            this.toggleSwiperCtaJobs(false);
        }
    }
}
